/* eslint-disable-next-line  no-unused-vars */
import React, { createElement, useContext, useEffect, useState } from "react";

import {
  Container,
  TextField,
  Button,
  MenuItem,
  Box,
  Select,
  InputLabel,
  FormControl,
  FormHelperText,
  Alert,
  Typography,
  IconButton,
  Tooltip,
  Avatar,
  useMediaQuery,
} from "@mui/material";

import { DataGrid } from "@mui/x-data-grid";

import ViewerContext from "../../context/ViewerContext";
import ModalDialog from "./ModalDialog";
import PropTypes from "prop-types";
import axios from "axios";
import {
  CheckCircleOutline,
  InfoOutlined,
  EditIcon,
  EditRounded,
  Delete,
} from "@mui/icons-material";
import loaderHelper from "../loader/loaderHelper";
import AddStationDialog from "./AddStationDialog";

const baseUrl = process.env.API_GATEWAY || "https://satmon.fly.dev";

export default function StationConfiguration(props) {
  const { openDialog, setOpenDialog, celestrakId, refreshFunction } = props;
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState();
  const [rows, setRows] = useState();
  const [editRow, setEditRow] = useState(null);
  const [messageOption, setMessageOption] = useState({
    show: false,
    severity: "success",
    messageText: "",
  });

  const isMobile = useMediaQuery("(max-width:600px)");

  const [option, setOption] = useState({
    celestrak_id: "",
    freq_hz: "",
    polarization: "",
    bandwidth_hz: "",
    eirp_dbw: "",
  });

  useEffect(() => {
    console.log(messageOption);
  }, [messageOption]);

  useEffect(() => {
    if (openDialog) listStationsByConstellationId(celestrakId);
  }, [openDialog]);

  const showAlerMessage = (text, severity) => {
    setMessageOption({
      ...messageOption,
      severity: severity,
      messageText: text,
      show: true,
    });
  };

  const listStationsByConstellationId = async (constellationId) => {
    loaderHelper().open();
    showAlerMessage("Fetching satellites for " + constellationId, "info");
    setOption({
      celestrak_id: constellationId ? constellationId : "",
      freq_hz: "",
      polarization: "",
      bandwidth_hz: "",
      eirp_dbw: "",
    });

    try {
      let url = `${baseUrl}/rx-stations/${constellationId}`;

      const response = await fetch(url);
      if (!response.ok) {
        showAlerMessage(
          "No configuration found for " + constellationId,
          "warning"
        );

        loaderHelper().close();
        return;
      }
      const result = await response.json();
      if (result.length == 0) {
        setOpenAddDialog(true);
      }
      setRows(result);

      showAlerMessage("Configuration listed for " + constellationId, "success");
    } catch (error) {
      showAlerMessage(
        "Failed to fetch configuration data for " + constellationId,
        "error"
      );
      console.log(error);
    } finally {
    }

    loaderHelper().close();
  };

  const onCloseFunc = () => {
    setOpenDialog(false);
    loaderHelper().close();
  };

  const columns = [
    {
      field: "name",
      headerName: "Station Name",
      sortable: false,
      disableColumnFilter: true,
      disableColumnMenu: true,
      flex: 2,
    },
    {
      field: "latitude_degn",
      headerName: "Lat",
      sortable: false,
      disableColumnFilter: true,
      disableColumnMenu: true,
      flex: 1,
      hide: !isMobile,
    },
    {
      field: "longitude_dege",
      headerName: "Lon",
      sortable: false,
      disableColumnFilter: true,
      disableColumnMenu: true,
      flex: 1,
      hide: isMobile,
    },
    {
      field: "actions",
      headerName: "",
      sortable: false,
      disableColumnFilter: true,
      disableColumnMenu: true,
      flex: 2,
      renderCell: (params) => (
        <>
          <Tooltip title="Edit Station" arrow>
            <IconButton onClick={() => handleUpdate(params.row.id)}>
              <EditRounded variant="contained" color="primary" size="small" />
            </IconButton>
          </Tooltip>

          <Tooltip title="Delete Station" arrow>
            <IconButton onClick={() => handleDelete(params.row.id)}>
              <Delete
                variant="contained"
                color="error"
                size="small"
                style={{ marginLeft: 10 }}
              />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  ];

  // Handle delete row
  const handleDelete = (id) => {
    const selectedRow = rows.find((row) => row.id === id);
    setEditRow(selectedRow);

    setOpenDeleteDialog(true);
  };

  const onSubmitDeleteDialog = () => {
    deleteStation(editRow.id);
  };

  const deleteStation = async (id) => {
    try {
      loaderHelper().open();
      let url = `${baseUrl}/rx-stations/${celestrakId}/${id}`;

      const response = await axios.delete(url, {
        headers: {
          accept: "application/json",
        },
      });

      showAlerMessage("Rx Station succesfully deleted", "success");
      refreshFunction ? refreshFunction(true) : null;
    } catch (error) {
      showAlerMessage("Error seleting the Rx Station", "error");
    }

    setOpenDeleteDialog(false);

    listStationsByConstellationId(celestrakId);
  };

  // Handle update row
  const handleUpdate = (id) => {
    const selectedRow = rows.find((row) => row.id === id);
    setEditRow(selectedRow);
    setOpenAddDialog(true);
  };

  const handleAddStationFunc = () => {
    setEditRow({});
    setOpenAddDialog(true);
  };

  const callbackStationFunc = (data) => {
    listStationsByConstellationId(celestrakId);
    refreshFunction ? refreshFunction(true) : null;
  };
  return (
    <>
      <ModalDialog
        dialogTitle={"Station Configuration Screen"}
        openModal={openDialog}
        setOpenModal={setOpenDialog}
        onSubmit={onCloseFunc}
        submitButtonText={"Save"}
        onCancel={onCloseFunc}
        dialogContent={
          <Container>
            <Box component="form" sx={{ mt: 3 }}>
              <Button
                variant="contained"
                color="info"
                sx={{ marginLeft: "5px" }}
                onClick={handleAddStationFunc}
              >
                Add RX Station
              </Button>

              <DataGrid
                sx={{ margin: "10px 0" }}
                rows={rows}
                columns={columns}
                hideFooterPagination
                localeText={{
                  noRowsLabel: "No Rx Station Available",
                }}
              />
            </Box>
            {messageOption.show && (
              <Alert
                icon={<InfoOutlined fontSize="inherit" />}
                severity={messageOption.severity}
              >
                {messageOption.messageText}
              </Alert>
            )}
          </Container>
        }
      />
      {openAddDialog && (
        <AddStationDialog
          openDialog={openAddDialog}
          setOpenDialog={setOpenAddDialog}
          stationObject={editRow}
          celestrakId={celestrakId}
          callbackFunc={callbackStationFunc}
        />
      )}
      {openDeleteDialog && (
        <ModalDialog
          dialogTitle={"Delete Station"}
          openModal={openDeleteDialog}
          setOpenModal={setOpenDeleteDialog}
          onSubmit={onSubmitDeleteDialog}
          submitButtonText={"YES"}
          cancelButtonText={"NO"}
          onCancel={() => setOpenDeleteDialog(false)}
          dialogContent={
            <Container>
              <Box component="form" sx={{ mt: 3 }}>
                <b>
                  Are you sure you want to delete this station{" "}
                  {`${editRow.name}`}? This action cannot be undone.
                </b>
              </Box>
            </Container>
          }
        />
      )}
    </>
  );
}

StationConfiguration.propTypes = {
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
  celestrakId: PropTypes.string.isRequired,
  refreshFunction: PropTypes.func,
};
